import { Directive, Input } from '@angular/core';

@Directive()
export class DynamicTableColumnTemplate<
  ColumnTypeProps,
  Entity extends object = object
> {
  @Input() entity!: Entity;
  @Input() props!: ColumnTypeProps;
  @Input() additionalData!: Record<string, unknown>;
  @Input() focused: boolean = false;
}
